export { default } from "./box.component"
